// import composables
import useApi from '@/composables/useApi/useApi';
import { contentScrape } from '@/constants/ApiList';
import VersionPaths from '@/enums/VersionPaths';
import { IApiVersion } from '@/interfaces/IApiVersion';
import AuthApiVersion from '@/types/AuthApiVersion';

const { fetchData } = useApi();

contentScrape;

const baseUrl = contentScrape.baseUrl;

function getPageSourceByUrl(url: string) {
  return fetchData(
    baseUrl,
    { path: 'WebRequest/SendWebRequest', method: 'POST', requireAuth: true },
    {
      url,
    }
  );
}

async function apiinfo(): Promise<IApiVersion | null> {
  const { data, error } = await fetchData(baseUrl, {
    path: VersionPaths.CONTENT_SCRAPE_API,
    method: 'GET',
    requireAuth: false,
  }).json<AuthApiVersion>();

  if (error.value) {
    console.error('Error fetching API info:', error.value);
    return null;
  }

  // Map AuthApiVersion to IApiVersion
  const apiVersion: IApiVersion = {
    name: data.value?.appName || 'crm-ft-api-content-creation',
    title: data.value?.displayName || 'Content Scraper API',
    version: data.value?.appVersion || '',
    lastUpdated: data.value?.appReleaseDate || '',
    environment: data.value?.environment || '',
    releaseSignature: data.value?.appReleaseSignature || '',
    lastFetched: new Date(),
    isLoading: false,
    isSuccess: true,
  };

  return apiVersion;
}

export default {
  getPageSourceByUrl,
  apiinfo,
};
